import { render, staticRenderFns } from "./EditSubModalityChosen.vue?vue&type=template&id=276ef5d4"
import script from "./EditSubModalityChosen.vue?vue&type=script&lang=js"
export * from "./EditSubModalityChosen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports